<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div>
        <div class="d-flex align-items-center">
            <h5 class="m-0">{{ invite.name }}</h5>
            <span class="ml-2 badge badge-pill badge-secondary" :title="invite.code">Invited</span>
            <div class="flex-fill"></div>
            <button class="btn btn-outline-secondary btn-icon btn-menu invite-copy"
                    v-on:click="copyInviteLink"
                    title="Copy invitation link">
                <i class="fas fa-link"></i></button>
            <button class="btn btn-outline-secondary btn-icon btn-menu invite-cancel"
                    v-on:click="cancelInvite"
                    title="Cancel invitation">
                <i class="fas fa-trash"></i></button>
            <input hidden type="text" :id="'input-' + invite.code"/>
        </div>
        <small class="text-muted">{{ invite.email }}</small>
    </div>
</template>

<script lang="ts" src="./InviteItem.ts"></script>
